export function formatChange(percent: number): string {
  if (percent === 0) return "0.0%";
  return `${percent > 0 ? "+" : "−"}${Math.abs(percent).toFixed(1)}%`;
}
